export const MAP_API_KEY = "AIzaSyDIpmXLpo-0swTfI8squxtVHHuJHhW7oxc";
